module.exports = __webpack_public_path__ + "static/media/pay_level.fc84b26d.png";